import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";
class ProductTyped {
	@Field()
	public  baseType:String;
}

@Entity({one: "product", many: "products"})
export class Product {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public subTitle: string;

	@Field()
	public displayName: string;

	@Field({ entity: ProductTyped })
	public type: ProductTyped;

}



// WEBPACK FOOTER //
// ./src/panels/userSubscriptions/entities/Product.ts